import React, { useState, useEffect, Fragment } from 'react';
import { useHistory, Link, useParams } from 'react-router-dom';
import Select from 'react-select';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tooltip, Button, CircularProgress
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CopyrightIcon from '@mui/icons-material/Copyright';
// Assume fetchData and postData are defined elsewhere
import { fetchData, updateData, postData } from '../../../apiService';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Checkbox,
} from "@mui/material";

const SaleDetails = () => {

    const { id } = useParams(); // Use useParams to get the id from the URL 
    const history = useHistory();
    const { isAuthenticated, companyId, userId, permissions, token, logout, branchstate, branchId } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated]);

    const [formData, setFormData] = useState({
        CompanyId: companyId,
        CreatedBy: userId,
    });

    const [selectedItems, setSelectedItems] = useState([]);

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };

    //handle search [ITEM SEARCH]    
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const filteredData = selectedItems.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    useEffect(() => {
        fetchData('SaleApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Sale);
                    setSelectedItems(response.response_data.SaleDetails);
                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);

    return (
        <div style={{ fontFamily: "Segoe UI, sans-serif", fontSize: "12px", width: "100%", padding: "6px", boxSizing: "border-box", backgroundColor: "#f5f5f5" }}>

            {/* ── Color tokens & shared styles ── */}
            {(() => { return null; })()}

            {/* ── Top action bar ── */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px", gap: "8px" }}>
                <span style={{ fontWeight: 700, fontSize: "13px", color: "#1a7a4a" }}>Sale Details</span>
                <div style={{ display: "flex", gap: "8px" }}>
                    <Link to="/SaleIndex" onClick={() => localStorage.setItem("shouldReload", "true")}
                        style={{ height: "30px", padding: "0 14px", borderRadius: "4px", border: "1px solid #d1d5db", backgroundColor: "#fff", color: "#374151", fontWeight: 600, fontSize: "12px", cursor: "pointer", display: "flex", alignItems: "center", textDecoration: "none" }}>
                        ← Back
                    </Link>
                </div>
            </div>

            {/* ── Bill details card ── */}
            {(() => {
                // ── Color tokens ──
                const GN  = "#1a7a4a";
                const GNL = "#e8f5ee";
                const GND = "#155d38";
                // ── Shared input styles (read-only) ──
                const inp2  = { border: "1px solid #d1d5db", borderRadius: "4px", fontSize: "12px", height: "30px", width: "100%", padding: "0 8px", outline: "none", backgroundColor: "#f8fafa", boxSizing: "border-box", color: "#1a2e2e", cursor: "default" };
                const inp2R = { ...inp2, textAlign: "right" };
                const lbl2  = { fontSize: "10px", color: "#6b7280", display: "block", marginBottom: "2px", fontWeight: 500 };
                // ── Section styles ──
                const sectionBox  = { backgroundColor: "#fff", border: "1px solid #e5e7eb", borderRadius: "6px", marginBottom: "8px", overflow: "hidden" };
                const sectionHead = { backgroundColor: GNL, borderBottom: `2px solid ${GN}`, padding: "5px 12px" };
                const sectionTitle = { fontSize: "11px", fontWeight: 700, color: GND, textTransform: "uppercase", letterSpacing: "0.5px" };
                // ── Alias for items table ──
                const inp  = inp2;
                const inpR = inp2R;
                return (
                    <>
                        {/* ══ SECTION 1 — Sale Information ══ */}
                        <div style={sectionBox}>
                            <div style={sectionHead}><span style={sectionTitle}>Sale Information</span></div>
                            <div style={{ padding: "8px 12px", display: "flex", gap: "10px", alignItems: "flex-end", flexWrap: "wrap" }}>
                                {/* Bill No */}
                                <div style={{ flex: "0 0 110px" }}>
                                    <label style={lbl2}>Bill No</label>
                                    <input type="text" value={`${formData.BillNumber || ""}/${formData.FinYear || ""}`} readOnly style={inp2} />
                                </div>
                                {/* Bill Date */}
                                <div style={{ flex: "0 0 130px" }}>
                                    <label style={lbl2}>Bill Date</label>
                                    <input type="date" value={formatDateForInput(formData.BillDate)} readOnly style={inp2} />
                                </div>
                                {/* Customer */}
                                <div style={{ flex: "1 1 170px" }}>
                                    <label style={lbl2}>Customer</label>
                                    <input type="text" value={formData.CustomerName || ""} readOnly style={inp2} />
                                </div>
                                {/* Ph.No */}
                                <div style={{ flex: "0 0 120px" }}>
                                    <label style={lbl2}>Ph.No</label>
                                    <input type="text" value={formData.ContactNumber || ""} readOnly style={inp2} />
                                </div>
                                {/* GST No */}
                                <div style={{ flex: "0 0 130px" }}>
                                    <label style={lbl2}>GST No</label>
                                    <input type="text" value={formData.GSTNumber || ""} readOnly style={inp2} />
                                </div>
                                {/* Invoice Type */}
                                <div style={{ flex: "0 0 140px" }}>
                                    <label style={lbl2}>Invoice Type</label>
                                    <input type="text" value={formData.InvoiceTypeName || ""} readOnly style={inp2} />
                                </div>
                                {/* Salesman */}
                                <div style={{ flex: "0 0 140px" }}>
                                    <label style={lbl2}>Salesman</label>
                                    <input type="text" value={formData.SalesManName || ""} readOnly style={inp2} />
                                </div>
                                {/* Store Location */}
                                <div style={{ flex: "0 0 180px" }}>
                                    <label style={lbl2}>Store Location</label>
                                    <input type="text" value={formData.StoreLocationName || ""} readOnly style={inp2} />
                                </div>
                                {/* Wholesale checkbox (read-only) */}
                                <div style={{ display: "flex", alignItems: "center", gap: "5px", paddingBottom: "4px" }}>
                                    <input id="IsWholeSaleRateDetails" type="checkbox" checked={formData.IsWholeSaleRate || false} disabled
                                        style={{ width: "14px", height: "14px", accentColor: GN, cursor: "default" }} />
                                    <label htmlFor="IsWholeSaleRateDetails" style={{ fontSize: "10px", fontWeight: 700, color: GN, whiteSpace: "nowrap" }}>Whole Sale</label>
                                </div>
                            </div>
                        </div>

                        {/* ══ SECTION 2 — Sale Items ══ */}
                        <div style={sectionBox}>
                            <div style={{ ...sectionHead, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "6px" }}>
                                <span style={sectionTitle}>Sale Items ({filteredData.length} items)</span>
                            </div>
                            {/* Items table */}
                            <div style={{ maxHeight: "320px", overflowY: "auto" }}>
                                {filteredData.length === 0 ? (
                                    <div style={{ backgroundColor: GNL, padding: "20px", textAlign: "center", fontSize: "12px", color: GND }}>No items found</div>
                                ) : (
                                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
                                        <thead style={{ backgroundColor: GN, color: "#fff", position: "sticky", top: 0 }}>
                                            <tr>
                                                {["#", "Item", "Qty", "Rate", "Disc%", "Disc Amt", "GST%", "GST Amt", "Taxable", "Total"].map((h, i) => (
                                                    <th key={i} style={{ padding: "6px 4px", textAlign: i > 1 ? "right" : "left", fontSize: "10px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.4px", whiteSpace: "nowrap" }}>{h}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredData.map((item, index) => (
                                                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#fff" : GNL, borderBottom: "1px solid #e5e7eb" }}>
                                                    <td style={{ padding: "3px 6px", textAlign: "center", whiteSpace: "nowrap" }}>{index + 1}</td>
                                                    <td style={{ padding: "3px 4px", minWidth: "160px", fontWeight: 600 }}>{item.ItemName}</td>
                                                    <td style={{ padding: "2px", width: "70px" }}><input type="number" value={item.Quantity} readOnly style={{ ...inpR, height: "24px", borderRadius: "4px" }} /></td>
                                                    <td style={{ padding: "2px", width: "100px" }}><input type="number" value={item.Rate || 0} readOnly style={{ ...inpR, height: "24px", borderRadius: "4px" }} /></td>
                                                    <td style={{ padding: "2px", width: "80px" }}><input type="number" value={item.DiscountPercentage || 0} readOnly style={{ ...inpR, height: "24px", borderRadius: "4px" }} /></td>
                                                    <td style={{ padding: "2px", width: "90px" }}><input value={item.DiscountAmount || 0} readOnly style={{ ...inpR, height: "24px", borderRadius: "4px" }} /></td>
                                                    <td style={{ padding: "3px 4px", textAlign: "right", whiteSpace: "nowrap", fontSize: "11px", color: "#6b7280" }}>{item.GSTRate ? parseFloat(item.GSTRate) : 0}%</td>
                                                    <td style={{ padding: "2px", width: "90px" }}><input value={(parseFloat(item.CGSTAmount || 0) + parseFloat(item.SGSTAmount || 0) + parseFloat(item.IGSTAmount || 0)).toFixed(2)} readOnly style={{ ...inpR, height: "24px", borderRadius: "4px" }} /></td>
                                                    <td style={{ padding: "2px", width: "100px" }}><input value={item.TaxableAmount || 0} readOnly style={{ ...inpR, height: "24px", borderRadius: "4px" }} /></td>
                                                    <td style={{ padding: "2px", width: "100px" }}><input value={item.TotalAmount || 0} readOnly style={{ ...inpR, height: "24px", borderRadius: "4px", fontWeight: 700, color: GND }} /></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>

                        {/* ══ SECTION 3 — Bottom: Additional Charges + Summary ══ */}
                        <div style={{ display: "flex", gap: "10px", alignItems: "flex-start" }}>
                            {/* Left: Additional Charges */}
                            <div style={{ ...sectionBox, flex: "1 1 0", marginBottom: 0 }}>
                                <div style={sectionHead}><span style={sectionTitle}>Additional Charges</span></div>
                                <div style={{ padding: "10px 12px" }}>
                                    {/* Row 1: Freight, Packing, TCS, Cash, UPI, Card, Credit Amount */}
                                    <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                                        <div style={{ flex: "1 1 0" }}>
                                            <label style={lbl2}>Freight <span style={{ color: "#6b7280" }}>({formData.FreightGSTRate}% GST: {formData.FreightGSTAmount})</span></label>
                                            <input type="number" value={formData.FreightAmount || 0} readOnly style={inp2R} />
                                        </div>
                                        <div style={{ flex: "1 1 0" }}>
                                            <label style={lbl2}>Packing <span style={{ color: "#6b7280" }}>({formData.PackingGSTRate}% GST: {formData.PackingGSTAmount})</span></label>
                                            <input type="number" value={formData.PackingAmount || 0} readOnly style={inp2R} />
                                        </div>
                                        <div style={{ flex: "1 1 0" }}>
                                            <label style={lbl2}>TCS Amount</label>
                                            <input type="number" value={formData.TCSAmount || 0} readOnly style={inp2R} />
                                        </div>
                                        <div style={{ flex: "1 1 0" }}>
                                            <label style={lbl2}>Cash Amount</label>
                                            <input type="number" value={formData.CashAmount || 0} readOnly style={{ ...inp2R, fontWeight: 700, color: "#059669" }} />
                                        </div>
                                        <div style={{ flex: "1 1 0" }}>
                                            <label style={lbl2}>UPI Amount</label>
                                            <input type="number" value={formData.UPIAmount || 0} readOnly style={{ ...inp2R, fontWeight: 700, color: "#059669" }} />
                                        </div>
                                        <div style={{ flex: "1 1 0" }}>
                                            <label style={lbl2}>Card Amount</label>
                                            <input type="number" value={formData.CardAmount || 0} readOnly style={{ ...inp2R, fontWeight: 700, color: "#059669" }} />
                                        </div>
                                        <div style={{ flex: "1 1 0" }}>
                                            <label style={lbl2}>Credit Amount</label>
                                            <input type="text" value={formData.BalanceAmount || 0} readOnly
                                                style={{ ...inp2R, fontWeight: 700, color: parseFloat(formData.BalanceAmount) > 0 ? "#ef4444" : "#1a2e2e", backgroundColor: parseFloat(formData.BalanceAmount) > 0 ? "#fef2f2" : "#f8fafa" }} />
                                        </div>
                                    </div>
                                    {/* Row 2: Remarks, Bank */}
                                    <div style={{ display: "flex", gap: "8px", alignItems: "flex-end" }}>
                                        <div style={{ flex: "5 1 0" }}>
                                            <label style={lbl2}>Remarks</label>
                                            <input type="text" value={formData.Remarks || ""} readOnly style={inp2} />
                                        </div>
                                        <div style={{ flex: "1 1 0" }}>
                                            <label style={lbl2}>Bank</label>
                                            <input type="text" value={formData.BankName || ""} readOnly style={inp2} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Right: Summary */}
                            <div style={{ ...sectionBox, width: "200px", flexShrink: 0, marginBottom: 0 }}>
                                <div style={sectionHead}><span style={sectionTitle}>Summary</span></div>
                                <div style={{ padding: "8px 12px" }}>
                                    {[
                                        ["Subtotal", formData.TotalAmount, false],
                                        ["Discount", formData.DiscountAmount, true],
                                        ["Taxable", formData.TaxableAmount, false],
                                        ["CGST", formData.CGSTAmount, false],
                                        ["SGST", formData.SGSTAmount, false],
                                        ["IGST", formData.IGSTAmount, false],
                                        ["TCS", formData.TCSAmount, false],
                                        ["Round Off", formData.RoundOff, false],
                                    ].map(([label, val, isDiscount]) => (
                                        <div key={label} style={{ display: "flex", justifyContent: "space-between", padding: "3px 0", borderBottom: "1px solid #f3f4f6", fontSize: "11px" }}>
                                            <span style={{ color: "#6b7280" }}>{label}</span>
                                            <span style={{ color: isDiscount ? "#ef4444" : "#1a2e2e", fontWeight: 700, fontSize: "12px" }}>{isDiscount ? "- " : ""}₹{parseFloat(val || 0).toFixed(2)}</span>
                                        </div>
                                    ))}
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "5px 0 2px 0", borderTop: `2px solid ${GN}`, marginTop: "2px" }}>
                                        <span style={{ fontSize: "12px", fontWeight: 700, color: GND }}>Total</span>
                                        <span style={{ fontSize: "13px", fontWeight: 700, color: GN }}>₹{parseFloat(formData.GrandTotal || 0).toFixed(2)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                );
            })()}

        </div>
    );
}
export default SaleDetails;
